export default __webpack_public_path__ + "static/media/placeholder_private01-fr-mobile.0995bed5.png";